import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=38405e51&"
import script from "./Shipment.vue?vue&type=script&lang=js&"
export * from "./Shipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports